import { CellObject } from "xlsx-js-style";

export const exportDateTime: CellObject = {
  t: "d",
  z: "hh:mm DD/MM/YY",
  s: { alignment: { horizontal: "left" } },
};
export const exportDate: CellObject = {
  t: "d",
  z: "DD/MM/YY",
  s: { alignment: { horizontal: "left" } },
};

export const exportCurrency: CellObject = {
  t: "n",
  z: "$#,##0;[Red]-$#,##0",
};
export const exportPercentage: CellObject = {
  t: "n",
  z: "0.00%",
};
export const fillBlue = {
  patternType: "solid",
  fgColor: {
    rgb: "D6DDEB",
  },
};
export const fillGray = {
  patternType: "solid",
  fgColor: {
    rgb: "E7E6E6",
  },
};
export const fillYellow = {
  patternType: "solid",
  fgColor: {
    rgb: "FEEBC7",
  },
};
export const fillLightBlue = {
  patternType: "solid",
  fgColor: {
    rgb: "d8e1f9",
  },
};
export const fillBlueV2 = {
  patternType: "solid",
  fgColor: {
    rgb: "9eb4f0",
  },
};
export const fillPink = {
  patternType: "solid",
  fgColor: {
    rgb: "fbd4e7",
  },
};
export const fillLightYellow = {
  patternType: "solid",
  fgColor: {
    rgb: "fef5e3",
  },
};
export const fillOrange = {
  patternType: "solid",
  fgColor: {
    rgb: "FCE4D6",
  },
};

export const DefaultCellHeight = 15;
export const TitleCellHeight = 20;
export const CharactersInARow = 120;
export const TotalCharacterInCell = 17;
